import { Button, Card, Col, Form, Input, Row, Select, Space, theme } from 'antd';
import { useEffect } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import './MedProjectsFilterPanel.less';

const TOTAL_FIELD_COUNT = 6;

export default function MedProjectsFilterPanel({ filter, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(TOTAL_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            id: filter.id,
            name: filter.name,
            status: filter.status,
            createdBy: filter.createdBy,
            hidden: filter.hidden,
            isTesting: filter.isTesting,
        });
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    return (
        <Card
            size="small"
            className="medprojects-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="项目编号" name="id" style={filterFormItemStyle}>
                            <Input allowClear placeholder="项目编号或ID" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="项目名称" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="项目名称关键字" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="项目状态" name="status" style={filterFormItemStyle}>
                            <Select placeholder="项目状态" allowClear>
                                <Select.Option value={1}>已上架</Select.Option>
                                <Select.Option value={2}>已下架</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="医项目列表" name="hidden" style={filterFormItemStyle}>
                            <Select placeholder="医项目列表显示状态" allowClear>
                                <Select.Option value={0}>显示</Select.Option>
                                <Select.Option value={1}>隐藏</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="创建人" name="createdBy" style={filterFormItemStyle}>
                            <Input allowClear placeholder="创建人关键字" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="正式/测试" name="isTesting" style={filterFormItemStyle}>
                            <Select placeholder="选择是否测试项目" allowClear>
                                <Select.Option value={0}>正式项目</Select.Option>
                                <Select.Option value={1}>测试项目</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
